export * from './CurrentTextDisplay';
export { default } from './CurrentTextDisplay';
